export default (theme) => ({
  participants: {
    width: '100%',
    height: 340,
    padding: 20,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      height: 250,
    },
    [theme.breakpoints.down('sm')]: {
      height: 200,
    },
  },
  participantsWrapper: {
    overflowY: 'auto',
    height: 'calc(100% - 35px)',
    paddingRight: 10,
  },
  participant: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 10,
    width: '100%',
  },
  extendedParticipantInfoWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    width: '100%',
  },
  participantInfoWrapper: {
    width: 'calc(100% - 80px)',
  },
  participantName: {
    textTransform: 'capitalize',
    paddingRight: 10,
    width: 'auto',
  },
  participantControls: {
    display: 'flex',
  },
  participantIcon: {
    minWidth: 24,
    width: 24,
    fill: theme.palette.success.main,
    marginRight: 10,
  },
  disabledParticipantIcon: {
    fill: theme.palette.disabled.main,
  },
  controlIconWrap: {
    marginLeft: 10,
  },
  controlIcon: {
    fill: theme.palette.font.main,
  },
});
